import { SECONDARY_NAVIGATION, SIDEBAR_PRIMARY_NAVIGATION, type NavigationItem, type ViewId } from './navigation';

type Props = {
  activeView: ViewId;
  onNavigate: (viewId: ViewId) => void;
};

const NavigationGroup = ({
  activeView,
  items,
  label,
  onNavigate
}: Props & { items: readonly NavigationItem[]; label?: string }) => (
  <div className="sidebar-group">
    {label && <p className="sidebar-group-label">{label}</p>}
    {items.map(({ id, label: itemLabel, icon: Icon }) => (
      <button
        type="button"
        className="sidebar-link"
        data-active={activeView === id}
        aria-current={activeView === id ? 'page' : undefined}
        onClick={() => onNavigate(id)}
        key={id}
      >
        <Icon size={25} aria-hidden="true" />
        <span>{itemLabel}</span>
      </button>
    ))}
  </div>
);

const MAIN_NAVIGATION = [
  ...SIDEBAR_PRIMARY_NAVIGATION,
  ...SECONDARY_NAVIGATION.filter(({ id }) => id !== 'data')
] as const;

const DATA_NAVIGATION = SECONDARY_NAVIGATION.filter(({ id }) => id === 'data');

export const Sidebar = ({ activeView, onNavigate }: Props) => (
  <aside className="sidebar" aria-label="Desktop navigation">
    <div className="sidebar-brand">
      <span className="brand-mark" aria-hidden="true"><img src="/icons/icon-192.png" alt="" width="44" height="44" /></span>
      <span className="sidebar-brand-copy">
        <strong>Spooky Plan</strong>
        <small>Cozy Halloween Planner</small>
      </span>
    </div>
    <nav className="sidebar-navigation">
      <NavigationGroup activeView={activeView} items={MAIN_NAVIGATION} label="Planner" onNavigate={onNavigate} />
      <div className="sidebar-data-navigation">
        <img className="sidebar-companion" src="/assets/sidebar-cat-v0816.png" alt="" width="2048" height="2048" />
        <NavigationGroup activeView={activeView} items={DATA_NAVIGATION} onNavigate={onNavigate} />
      </div>
    </nav>
  </aside>
);
